import { Pagination, PaginationProps } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

const TranslatedPagination = (props: PaginationProps) => {
  const { t } = useTranslation('common');
  return <Pagination {...props} backLabel={t('back')} nextLabel={t('next')} />;
};

export default TranslatedPagination;
